<template>
  <div>
    <SpinnerLoading v-if="isLoading" color="blue" style="margin-top: 58px;" />
    <div v-else class="schedule-editor">
      <div class="time-row">
        <label class="time-label">{{ $t('startTime') }}</label>
        <input
          v-model="localFrom"
          type="time"
          class="time-input"
          :class="{ 'error-input': timeErrors.from }"
        >
      </div>
      <div class="time-row">
        <label class="time-label">{{ $t('endTime') }}</label>
        <input
          v-model="localTo"
          type="time"
          class="time-input"
          :class="{ 'error-input': timeErrors.to }"
        >
      </div>
      <p v-if="timeErrors.to" class="error-msg">
        {{ timeErrors.to }}
      </p>
      <div class="days-selector">
        <button
          v-for="(day, index) in localDays"
          :key="index"
          class="day-button"
          :class="{ active: day.enabled }"
          @click="toggleDay(index)"
        >
          {{ day.label }}
        </button>
      </div>
      <div class="schedule-button">
        <CamsButton
          priority="primary"
          :disabled="!hasActiveDays"
          @click="saveSchedule"
        >
          {{ $t('save') }}
        </CamsButton>
        <CamsButton class="cancel" priority="secondary" @click="closeDialog">
          {{ $t('cancel') }}
        </CamsButton>
      </div>
    </div>
  </div>
</template>

<script>
import {ACTION_CREATE_SCHEDULE, ACTION_EDIT_SCHEDULE, DAYS_OF_WEEK} from "@/store/analytics/schedules/index.js";
import {createEntityMixin} from "@/components/pacs/mixins.js";
/**
 *  Компонент создания и редактирования расписания
 *
 **/
export default {
  name: 'ScheduleAnalytics',
  mixins: [createEntityMixin],
  props: {
    analyticType: String,
    cameraNumber: String,
    from: {
      type: String,
      default: '09:00',
    },
    to: {
      type: String,
      default: '18:00',
    },
    days: {
      type: Array,
      default: () => [],
    },
    scheduleId: {
      type: Number,
      default: null,
    },
    settings: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      isLoading: false,
      localFrom: this.from,
      localTo: this.to,
      localDays: DAYS_OF_WEEK.map(day => ({
        ...day,
        enabled: this.days.includes(day.label)
      })),
      timeErrors: {
        from: '',
        to: '',
      },
    };
  },
  methods: {
    /**
     *  Метод создания и редактирования расписания два в одном. Если пришли с id, - редактируем.
     *
     **/
    async saveSchedule() {
      this.isLoading = true;
      const selectedLabels = this.localDays
        .filter(day => day.enabled)
        .map(day => day.label);
      this.timeErrors.from = '';
      this.timeErrors.to = '';
      try {
        if (this.scheduleId) {
          await this.$store.dispatch(`analytics/schedules/${ACTION_EDIT_SCHEDULE}`, {
            cameraNumber: this.cameraNumber,
            scheduleType: this.analyticType,
            scheduleId: this.scheduleId,
            schedule: {
              from: this.localFrom,
              to: this.localTo,
              days: selectedLabels,
            },
          });
          this.closeDialog(true);
        } else {
          await this.$store.dispatch(`analytics/schedules/${ACTION_CREATE_SCHEDULE}`, {
            cameraNumber: this.cameraNumber,
            scheduleType: this.analyticType,
            schedule: {
              from: this.localFrom,
              to: this.localTo,
              days: selectedLabels,
            },
          });
          this.closeDialog(true);
        }
      } catch (e) {
        console.error("Ошибка при сохранении расписания", e);
        const serverFields = e?.fields || e?.response?.data?.fields;
        const timeErrorMsg = serverFields?.settings?.[0]?.start_time?.[0];
        if (timeErrorMsg) {
          this.timeErrors.from = timeErrorMsg;
          this.timeErrors.to = timeErrorMsg;
        } else {
          this.timeErrors.to = 'Ошибка при сохранении расписания';
        }
      } finally {
        this.isLoading = false;
      }
    },

    toggleDay(index) {
      this.localDays[index].enabled = !this.localDays[index].enabled;
    },
  },
  computed: {
    /**
     *  Если не выбран день недели сохранение невозможно.
     *
     **/
    hasActiveDays() {
      return this.localDays.some(day => day.enabled);
    }
  },
};
</script>

<style lang="scss">
@use "./style.scss";
</style>
